const prefixedUrlAssets = {
  production: `${window.location.origin}/procurement`,
  // development: 'http://192.168.110.12:8088/procurement',
  // 注意:写相对路径 '/procurement',不要写 'http://localhost:8080/procurement' 这种绝对 URL。
  // 绝对 URL 在 8888 dev server 上跑时,axios 会从 127.0.0.1:8888 直接打 localhost:8080,
  // 触发跨域;后端 WebSecurityConfig 只开了 http.cors() 却没有 CorsConfigurationSource bean,
  // OPTIONS preflight 直接 403 Invalid CORS request。
  // 写相对路径后,axios 自动走当前页面同源,被 8888 dev server proxy 转发到 8080,不跨域。
  development: '/procurement',
  // development: 'http://39.98.121.212/procurement',
  // development: 'http://192.168.172.181:9001/procurement-dev',
  test: 'http://39.98.121.212:85/procurement',
};

// eslint-disable-next-line import/prefer-default-export
///export const prefixedUrlAsset = prefixedUrlAssets.test;
// export const prefixedUrlAsset = prefixedUrlAssets.test;
export const prefixedUrlAsset = prefixedUrlAssets.production;

